package com.milta.core.localization.translations.en

import com.milta.core.localization.SubscriptionExpiredStrings

internal val SubscriptionExpired = SubscriptionExpiredStrings(
    title = "Subscription expired",
    driverSoloMessage = "Your subscription has expired. Renew to continue.",
    patronMessage = "Your subscription has expired. Your team can no longer access Milta.",
    driverUnderPatronMessage = "Your organisation's subscription has expired. Contact your organisation to restore your access.",
    renewButton = "Renew",
    close = "Close",
    subscribeButtonTemplate = "Subscribe for %s",
    driverLinkCodeHint = "Working for an Enterprise? Give them this code: once linked, you are covered by their subscription.",
    checkAccessButton = "Check my access",
    accessStillUnavailable = "Access still unavailable",
)
